module.exports = __webpack_public_path__ + "assets/pi-firmware-role.9bfc4de3.svg";